/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Detail_Rating_Comment_PlaceholderInputs */

const en_directory_detail_rating_comment_placeholder = /** @type {(inputs: Directory_Detail_Rating_Comment_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Share what stood out (optional)`)
};

const zh_directory_detail_rating_comment_placeholder = /** @type {(inputs: Directory_Detail_Rating_Comment_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`说说你的使用感受（可选）`)
};

/**
* | output |
* | --- |
* | "Share what stood out (optional)" |
*
* @param {Directory_Detail_Rating_Comment_PlaceholderInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_detail_rating_comment_placeholder = /** @type {((inputs?: Directory_Detail_Rating_Comment_PlaceholderInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Detail_Rating_Comment_PlaceholderInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_detail_rating_comment_placeholder(inputs)
	return zh_directory_detail_rating_comment_placeholder(inputs)
});
export { directory_detail_rating_comment_placeholder as "directory.detail.rating_comment_placeholder" }